import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { CommonService } from '../../shared/common.service';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class LoginLayoutService {
    environment: any;

    constructor(public commonService: CommonService, private http: HttpClient) { }


    UserLogin(data: any): Observable<any> {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/UserLoginWeb', data);
    }

    signupUser(data: any): Observable<any> {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/SignUp', data);
    }

    forgotPassword(emailData: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/ForgotPasword', emailData);
    }
    
    
    signUp(signUpData: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/SignUp', signUpData);
    }
      
    // OTP verification method
    verifyOtp(otpData: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/VerifyOtp', otpData);
    }

    // Resend OTP in Sign up 
    resendOtp(userDat: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/ResendOtp', userDat);
    }

    forgotResendOtp(userData: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/ForgotResendOtp', userData);
    }

    // Forgot Verify OTP
    forgotverifyOtp(forgototpData: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/ForgotVerifyOtp', forgototpData);
    }
    
    // Reset Password
    resetPassword(resetData: any){
    return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/ResetPassword', resetData);
    }
}